import React from "react";
import "./TrainingInternshipZone.css";

const TrainingInternshipZone = () => {
  return (
    <section className="training-section">
      <div className="training-container">
        <div className="training-header">
          <h4 className="training-subtitle">From Learning to Earning</h4>
          <h2 className="training-title">
            Python Full Stack Training with Job Guarantee & Internship
          </h2>
          <p className="training-description">
            Learn from professionals who’ve been there, done that. Our Python
            Full Stack Training Program is not just about coding — it’s about
            becoming job-ready. With live projects, internship experience, and
            100% placement guidance, we make sure every learner gets their first
            job without compromise.
          </p>
        </div>

        <div className="timeline-container">
          <div className="timeline-item">
            <div className="timeline-icon">💡</div>
            <div className="timeline-content">
              <h3>Learn</h3>
              <p>
                Structured online learning with hands-on real-world projects.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-icon">⚙️</div>
            <div className="timeline-content">
              <h3>Practice</h3>
              <p>
                Code daily and build confidence through guided practice tasks.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-icon">💼</div>
            <div className="timeline-content">
              <h3>Intern</h3>
              <p>
                Gain real-time project experience and exposure with expert
                mentorship.
              </p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-icon">🎯</div>
            <div className="timeline-content">
              <h3>Get Hired</h3>
              <p>
                100% placement assistance and career support until you land your
                job.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainingInternshipZone;
